const __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof sharedComponents !== "undefined") return resolve();
	__webpack_require__.l("https://micro-leap-mfe-production27-login.web.app/sharedComponents/remoteEntry.js", (event) => {
		if(typeof sharedComponents !== "undefined") return resolve();
		const errorType = event && (event.type === 'load' ? 'missing' : event.type);
		const realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "sharedComponents");
}).then(() => (sharedComponents));